// extracted by mini-css-extract-plugin
export var box = "Box-module--box--kEwAd";